// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxesGroup_wrapper__pAfFw","checkboxesContent":"CheckboxesGroup_checkboxesContent__UVCHv","secondary":"CheckboxesGroup_secondary__r5JTC"};